import urlRoutingIdentifier from '../url/routing-identifier';

type T = () => string;

const f: T = () => {
    const routingId = urlRoutingIdentifier();
    return `https://${routingId ? `${routingId}.` : ''}${process.env.API_HOST || 'api.host'}`;
};

export default f;
